/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 7/18/20
 * Time: 2:50 AM
 */

// /*global ZoomMtg*/

import React, {Component} from 'react';
import './JoinClass.scss'
import {ZoomMtg} from '@zoomus/websdk';
import {withRouter} from "react-router";
import $ from 'jquery';
import * as config from '../../../const/config';
import * as constants from '../../../const/constants';
import {baseUrl, classId, random, start} from '../../../const/constants';
import * as commonFunc from '../../../utils/commonFunc';
import * as actionSpinnerCreator from "../../../store/domain/spinner/action";
import {connect} from "react-redux";
import * as studentService from "../../../services/student";
import {lang, language} from "../../../const/language";
import {isBrowser, isMobile} from "react-device-detect";
import {Form} from "react-bootstrap";

import {Button, Card, CardBody, Col, Row} from "reactstrap";
import Header from "../../../components/Header/Header";
import CardsFooter from "../../../components/Modals/Footers/CardsFooter";
import apiConfig from "../../../services/apiConfig";
import {Base64} from "js-base64";
import {notifyMessage} from "../../../utils/commonFunc";
import conf from "../../../services/apiConfig";
import * as classService from "../../../services/class";

class App extends Component {

    state = {
        zoomBody: null,
        init: false,
        eduLabApp: '',
        meetLink:'',
        typeMeeting:''
    };

    async componentDidMount() {
        document.documentElement.scrollTop = 0;
        document.scrollingElement.scrollTop = 0;
        this.refs.main.scrollTop = 0;
        let state = this.props.location.state;
        if (state.zoomMeetingJoinType === 'UNAUTHORIZED' || state.zoomMeetingJoinType !== undefined) {
            this.setState({typeMeeting: state.zoomMeetingJoinType});
            this.checkRouteState();
        } else {
            await this.setState({meetLink: this.props.location.state.link});
        }
    }


    goHome = () => {
        this.props.history.push(`${constants.BASE_ROUTE}${constants.HOME_INSTITUTE_ROUTE}`)
    };


    checkRouteState = async () => {

        let state = this.props.location.state;
        if (state) {
            await this.setState({
                zoomBody: JSON.parse(state)
            });
            this.meetingConfig(JSON.parse(state));
        } else {
            this.props.history.push(`${constants.BASE_ROUTE}${constants.HOME_MY_CLASS_ROUTE}`);
        }
    };
    meetingConfig = (data) => {
        this.changeLayout("none");
        let {userObj} = this.props;

        ZoomMtg.setZoomJSLib('https://jssdk.zoomus.cn/1.7.10/lib', "/av");
        ZoomMtg.preLoadWasm();
        ZoomMtg.prepareJssdk();

        let meetingConfig = {
            apiKey: config.ZOOM_API_KEY,
            meetingNumber: data.zoomMeetingId,
            passWord: data.zoomMeetingPassword,
            signature: data.zoomSignatureJwt,
            userName: userObj.name,
            role: config.ZOOM_ROLE,
            userEmail: (function () {
                try {
                    return commonFunc.b64DecodeUnicode(userObj.email);
                } catch (e) {
                    return userObj.email;
                }
            })(),
            lang: config.ZOOM_LANG,
            china: 0,
            leaveUrl: `${constants.BASE_ROUTE}${constants.HOME_MY_CLASS_ROUTE}`,
        };

        ZoomMtg.init({
            leaveUrl: meetingConfig.leaveUrl,
            webEndpoint: meetingConfig.webEndpoint,
            // disableVoIP: false, // optional
            disableReport: true, // optional
            disableInvite: true,
            disableRecord: true,
            meetingInfo: ['topic', 'host'],
            success: (success) => {
                console.log("Zoom init", success);
                this.props.spinnerHandler(false);
                const url = Base64.encode(`${apiConfig.serverUrl}/${apiConfig.basePath}`);
                const clzId = Base64.encode(`${data.classId}`);

                const ran = Base64.encode(Math.random().toString());
                this.setState({
                    init: true,
                    eduLabApp: `edulab://edulab.lk/${start}?${baseUrl}=${url}&${classId}=${clzId}&${ran}=${random}`
                })
            },
            error: (error) => {
                console.log("zoom init error", error)
            }
        });
    };
    changeLayout = (state) => {
        let root = $("#zmmtg-root");
        root.css("display", state);
        if (state === "block") {
            $("#root").css("display", "none")
        } else {
            $("#root").css("display", "block")
        }
    };
    componentWillMount() {
        this.checkRouteState();
    }

    componentWillUnmount() {
        this.changeLayout("none");
        clearInterval(this.timerid);
    }

    fetchVerifyDetailsInEveryMin = async () => {
        await studentService.verifyStudentCode().then(response => {});

        this.timerid = setInterval(async () => {
            await studentService.verifyStudentCode()
                .then(response => {})
        }, 60000);
    };

    startMeetingUnauthorized = async () => {
        let {userObj} = this.props;
        console.log(this.props.location.state);
        this.props.spinnerHandler({isSpin:true,type:15});
        if (this.props.location.state.classId !== undefined) {
            await studentService.getZoomDetails(this.props.location.state.classId)
                .then(response => {
                    this.props.spinnerHandler(false);
                    if (response.success && response.body.status === 'ACTIVE') {
                        let mc = {
                            apiKey: config.ZOOM_API_KEY,
                            meetingNumber: response.body.zoomMeetingId,
                            passWord: response.body.zoomMeetingPassword,
                            signature: response.body.zoomSignatureJwt,
                            userName: userObj.name + '_' + response.body.mask,
                        };
                        // this.fetchVerifyDetailsInEveryMin();
                        // window.location.href = `${conf.redirect}/join/index.html?${constants.ID}=${mc.meetingNumber}&${constants.SIGNATURE}=${mc.signature}&${constants.USERNAME}=${mc.userName}&${constants.PASSWORD}=${mc.passWord}`
                        if (isMobile) {
                            // setTimeout(() => {
                            //     this.props.history.push(`${constants.BASE_ROUTE}${constants.HOME_JOIN_CLASS_ERROR_ROUTE}`);
                            // }, 1500);
                            window.open(`zoomus://zoom.us/join?confno=${mc.meetingNumber}&pwd=${mc.passWord}&uname=${mc.userName}`, '_default')
                        } else if (isBrowser) {
                            window.open(`zoommtg://zoom.us/join?confno=${mc.meetingNumber}&pwd=${mc.passWord}&uname=${mc.userName}&token=${mc.signature}`, '_blank')
                        }
                    } else {
                        notifyMessage(response.message)
                    }
                })
                .catch(error => {
                    this.props.spinnerHandler(false);
                    console.log(error)
                    notifyMessage('Meeting has not started yet!');
                })
        }
        else if (this.props.location.state.courseId !== undefined && this.props.location.state.classId === undefined){
            await studentService.getZoomDetailsCourse(this.props.location.state.courseId)
                .then(response => {
                    this.props.spinnerHandler(false);
                    if (response.success){
                        let mc = {
                            apiKey: config.ZOOM_API_KEY,
                            meetingNumber: response.body.zoomMeetingId,
                            passWord: response.body.zoomMeetingPassword,
                            signature: response.body.zoomSignatureJwt,
                            userName: userObj.name+'_'+response.body.mask,
                        };
                        // this.fetchVerifyDetailsInEveryMin();
                        // window.location.href = `${conf.redirect}/join/index.html?${constants.ID}=${mc.meetingNumber}&${constants.SIGNATURE}=${mc.signature}&${constants.USERNAME}=${mc.userName}&${constants.PASSWORD}=${mc.passWord}`
                        if (isMobile) {
                            // setTimeout(() => {
                            //     this.props.history.push(`${constants.BASE_ROUTE}${constants.HOME_JOIN_CLASS_ERROR_ROUTE}`);
                            // }, 1500);
                            window.open(`zoomus://zoom.us/join?confno=${mc.meetingNumber}&pwd=${mc.passWord}&uname=${mc.userName}`, '_default')
                        } else if (isBrowser) {
                            window.open(`zoommtg://zoom.us/join?confno=${mc.meetingNumber}&pwd=${mc.passWord}&uname=${mc.userName}&token=${mc.signature}`, '_blank')
                        }
                    } else {
                        notifyMessage(response.message)
                    }
                })
                .catch(error => {
                    this.props.spinnerHandler(false);
                    console.log(error)
                    notifyMessage('Meeting has not started yet!');
                })
        }
    }


    startMeeting = () => {
        console.log("Authorized");
        let {userObj} = this.props;
        if (isMobile) {
            window.open(this.props.location.state.link)
        } else if (isBrowser) {
            window.open(this.props.location.state.link)
        }
    };



    // startMeetingUnauthorized = () => {
    //     let {userObj} = this.props;
    //     console.log(this.props.location.state);
    //     if (isMobile) {
    //         setTimeout( () => {
    //             this.props.history.push(`${constants.BASE_ROUTE}${constants.HOME_JOIN_CLASS_ERROR_ROUTE}`);
    //         }, 1500);
    //         window.location = `zoomus://zoom.us/join?confno=${this.props.location.state.zoomMeetingId}&pwd=${this.props.location.state.zoomMeetingPassword}&uname=${userObj.name}&token=${this.props.location.state.zoomSignatureJwt}&stype=99`
    //     } else if (isBrowser) {
    //         window.open(`zoommtg://zoom.us/join?confno=${this.state.zoomBody.zoomMeetingId}&pwd=${this.state.zoomBody.zoomMeetingPassword}&uname=${userObj.name}&token=${this.state.zoomBody.zoomSignatureJwt}&stype=99`, '_blank')
    //         //  zoomus://zoom.us/join?confno=${mc.meetingNumber}&pwd=${mc.passWord}&uname=${mc.userName}&token=${mc.signature}&stype=99
    //     }
    // };


    onBack = () => {
        window.history.back();
    };

    render() {
        return (
            <div>
                <Header/>
                <main ref="main" className={"join-class"}>
                    <div className="intro">
                        <button className={"home-btn"}
                                onClick={() => this.onBack()}>
                            <i className="icofont-long-arrow-left"/>
                            {language[lang].BackToTour}
                        </button>
                    </div>
                    <div className="trapezoid "></div>

                    <Card>
                        <CardBody>
                            <div align="left">

                                <>
                                    {/*<Row style={{alignItems: 'center'}}>*/}
                                    {/*    <Col xs="12" className="link-respo">*/}
                                    {/*        <div style={{marginLeft: '25px',marginBottom: '25px'}} className="link-title">*/}
                                    {/*            {language[lang].joinZoom}*/}
                                    {/*        </div>*/}
                                    {/*    </Col>*/}
                                    {/*    <Col xs="12" className="link-respo">*/}
                                    {/*        <input id='textCopy' readOnly={true} className="link-style "*/}
                                    {/*               style={{*/}
                                    {/*                   color: 'blue',*/}
                                    {/*                   marginLeft: '10px',*/}
                                    {/*                   width: '100%',*/}
                                    {/*                   borderWidth: 0,*/}
                                    {/*                   border: 'none'}}*/}
                                    {/*            // defaultValue={window.location.origin}*/}
                                    {/*               defaultValue={this.state.meetLink}*/}
                                    {/*        />*/}
                                    {/*    </Col>*/}
                                    {/*    <Col xs="12" className="link-respo">*/}
                                    {/*        <div*/}
                                    {/*            style={{*/}
                                    {/*                width: '65px',*/}
                                    {/*                padding: '5px',*/}
                                    {/*                borderRadius: '5px',*/}
                                    {/*                cursor: 'pointer',*/}
                                    {/*                marginRight: '10px'*/}
                                    {/*            }}*/}
                                    {/*            className='btn-primary float-right'*/}
                                    {/*            onClick={() => {*/}
                                    {/*                let copyText = document.getElementById("textCopy");*/}
                                    {/*                copyText.select();*/}
                                    {/*                document.execCommand("copy");*/}
                                    {/*            }}*/}
                                    {/*        >*/}
                                    {/*            <i className="fa fa-copy" style={{marginRight: '3px'}}/>*/}
                                    {/*            copy*/}
                                    {/*        </div>*/}
                                    {/*    </Col>*/}
                                    {/*</Row>*/}
                                    <Row>
                                        <Col className="colPadding" md={12}>


                                            <Form.Group as={Col} controlId="lessonName">
                                                <Form.Label column>
                                                    <strong>{language[lang].JoinTheClass}</strong>
                                                </Form.Label>
                                                <Button className="com-btn log-btn normal-txt "
                                                        onClick={() =>
                                                            this.state.typeMeeting ==='UNAUTHORIZED' ?
                                                                this.startMeetingUnauthorized() : this.startMeeting()}
                                                >
                                                    {language[lang].JoinTheClass}</Button>

                                            </Form.Group>


                                        </Col>
                                    </Row>
                                </>

                            </div>
                        </CardBody>
                    </Card>

                </main>
                <CardsFooter/>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    currentModal: state.modal.currentModal,
    userObj: state.student.userObj
});
const mapDispatchToProps = (dispatch) => ({
    spinnerHandler: data => dispatch(actionSpinnerCreator.spinnerHandler(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(App));
